import { FormEvent, useEffect, useState } from "react";
import PackageJson from "../../../package.json";
import { useAuth } from "../../hooks/auth";

import * as Yup from "yup";

import * as S from "./styles";
import { Input } from "../SignIn/components/Input";
import { MdKey } from "react-icons/md";
import { SignInButton } from "../SignIn/components/SignInButton";
import { Logo } from "../SignIn/components/Logo";
import { useTranslation } from "react-i18next";

export function PinSignIn() {
  const { authError, pinSignIn, isLoading, signOut } = useAuth();

  const { t } = useTranslation();

  const [pin, setPin] = useState("");

  const [error, setError] = useState<string | undefined>(authError);

  async function handlePinSignIn(event: FormEvent) {
    event.preventDefault();
    setError("");

    if (pin.length < 4) return setError(t("pinMustHave4Numbers"));

    try {
      await pinSignIn(pin);
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        setError(err.message);
      }
    }
  }

  const handleLogout = () => {
    signOut();
  };

  useEffect(() => {
    const shopStoraged = localStorage.getItem("@Incycle:shopSelected");
    const parsedShopStoraged = shopStoraged ? JSON.parse(shopStoraged) : "";

    !parsedShopStoraged && signOut();
  }, []);

  return (
    <S.Container>
      <S.Content autoComplete="off" onSubmit={handlePinSignIn}>
        <S.ImageContainer>
          <Logo />
        </S.ImageContainer>

        <Input
          label={t("pin")}
          isPassword
          name="password"
          autoComplete="new-password"
          value={pin}
          onChange={(value) => {
            setError("");
            setPin(value.target.value);
          }}
          icon={<MdKey />}
          errorMessage={error}
        />

        <SignInButton
          type="submit"
          title={t("signIn")}
          isLoading={isLoading}
          width="100%"
          height="3.5rem"
        />
      </S.Content>

      <S.LogoutContainer>
        <span>{t("or")}</span>
        <button onClick={handleLogout}>{t("logout")}</button>
      </S.LogoutContainer>

      <S.VersionContainer>
        <p>
          {t("version")} {PackageJson.version}
        </p>
      </S.VersionContainer>
    </S.Container>
  );
}
